import type { BrandSpecial } from '@iheartjane/data-access';
import { useMemo } from 'react';

import { useJaneUser } from '@jane/shared/data-access';
/* eslint-disable-next-line no-restricted-imports */
import type { PendingCartProduct } from '@jane/shared/models';
import { brandSpecialOrProductHasSegments } from '@jane/shared/util';

export const useNeedsSignInForEligibility = ({
  brandSpecial,
  cartProduct,
}: {
  brandSpecial?: Pick<BrandSpecial, 'special_type' | 'rules'>;
  cartProduct?: Pick<PendingCartProduct, 'brand_special_has_segment_rules'>;
}) => {
  const { data: janeUser } = useJaneUser();

  const needsSignInForEligibility = useMemo(() => {
    if (janeUser?.user.authenticated) {
      return false;
    }

    return brandSpecialOrProductHasSegments({
      brandSpecial,
      cartProduct,
    });
  }, [janeUser?.user.authenticated, brandSpecial]);

  return needsSignInForEligibility;
};
